var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcThreeDotVertical(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "5px",
    viewBox: "0 0 23 5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icThreeDotVertical") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M333.125,42.5833333 C331.974407,42.5833333 331.041667,41.6505932 331.041667,40.5 C331.041667,39.3494068 331.974407,38.4166667 333.125,38.4166667 C334.275593,38.4166667 335.208333,39.3494068 335.208333,40.5 C335.208333,41.6505932 334.275593,42.5833333 333.125,42.5833333 Z M342.5,42.5833333 C341.349407,42.5833333 340.416667,41.6505932 340.416667,40.5 C340.416667,39.3494068 341.349407,38.4166667 342.5,38.4166667 C343.650593,38.4166667 344.583333,39.3494068 344.583333,40.5 C344.583333,41.6505932 343.650593,42.5833333 342.5,42.5833333 Z M351.875,42.5833333 C350.724407,42.5833333 349.791667,41.6505932 349.791667,40.5 C349.791667,39.3494068 350.724407,38.4166667 351.875,38.4166667 C353.025593,38.4166667 353.958333,39.3494068 353.958333,40.5 C353.958333,41.6505932 353.025593,42.5833333 351.875,42.5833333 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Views",
    transform: "translate(-331.000000, -207.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/User-ShortDesc",
    transform: "translate(0.000000, 169.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icThreeDotVertical",
    fill: "#333333",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcThreeDotVertical);
export default __webpack_public_path__ + "static/media/icThreeDotVertical.f5e881122e00a406ce9c476a59aba4c6.svg";
export { ForwardRef as ReactComponent };